<template>
  <RevDrawer :name="MODAL_NAMES.BACK_UP" :title="i18n(translations.modalName)">
    <template #body>
      <div class="space-y-24">
        <RevIllustration
          alt="BackUp Header"
          class="w-full"
          :height="150"
          src="/img/product/jp/backup_modal_header.png"
          :width="330"
        />

        <BenefitsTable>
          <template #firstColumnTitle>
            <RevIllustration
              alt="BackUpPlus logo"
              class="inline-block align-middle"
              :height="27"
              src="/img/insurance/backUpLogo.svg"
              :width="80"
            />
          </template>
          <template #secondColumnTitle>
            <div class="text-static-default-hi body-1">
              {{ i18n(translations.warranty) }}
            </div>
          </template>

          <template #rows>
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="true"
              :title="i18n(translations.comparisonTable1)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable2)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable4)"
            />
          </template>
        </BenefitsTable>
        <div class="space-y-24">
          <h2 class="heading-2 text-center">
            {{ i18n(translations.contentTitle) }}
          </h2>
          <p class="body-1">
            {{ i18n(translations.contentDescriptionPart1) }}
          </p>
          <p class="body-1">{{ i18n(translations.contentDescriptionPart2) }}</p>
          <RevButton full-width="always" :to="articleUrl" variant="secondary">{{
            i18n(translations.cta)
          }}</RevButton>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useZendeskFaqBaseUrl } from '@backmarket/nuxt-layer-base/composables/useZendeskFaqBaseUrl'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'

import translations from './BackUpModal.translations'
import BenefitRow from './components/BenefitRow/BenefitRow.vue'
import BenefitsTable from './components/BenefitsTable/BenefitsTable.vue'

const i18n = useI18n()
const { zendeskFaqBaseUrl } = useZendeskFaqBaseUrl()

const articleUrl = computed(
  () => `${zendeskFaqBaseUrl}/articles/16665031731228`,
)
</script>
